import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  Badge,
  Switch,
  FormControlLabel,
  Divider,
  Rating,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Inventory as BrandIcon,
  Info as InfoIcon,
  Refresh as RefreshIcon,
  Visibility as ViewIcon,
  LocalOffer as TagIcon,
  Language as WebsiteIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Business as CompanyIcon,
  Star as StarIcon,
  Verified as VerifiedIcon,
  TrendingUp as PopularIcon,
  CheckCircle as CheckCircleIcon,
  Image as ImageIcon,
} from "@mui/icons-material";

const BrandMaster = () => {
  const [brandData, setBrandData] = useState([
    { 
      id: 1, 
      brandCode: "BRD001",
      brandName: "Dell", 
      country: "United States",
      website: "www.dell.com",
      email: "contact@dell.com",
      phone: "+1-800-624-9897",
      description: "Leading computer technology company",
      productCount: 45,
      rating: 4.5,
      status: "Active",
      isVerified: true,
      isPremium: true,
      displayOrder: 1,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
    { 
      id: 2, 
      brandCode: "BRD002",
      brandName: "HP", 
      country: "United States",
      website: "www.hp.com",
      email: "support@hp.com",
      phone: "+1-800-474-6836",
      description: "Hewlett-Packard computers and printers",
      productCount: 38,
      rating: 4.3,
      status: "Active",
      isVerified: true,
      isPremium: true,
      displayOrder: 2,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
    { 
      id: 3, 
      brandCode: "BRD003",
      brandName: "Logitech", 
      country: "Switzerland",
      website: "www.logitech.com",
      email: "info@logitech.com",
      phone: "+41-21-863-5111",
      description: "Computer peripherals and accessories",
      productCount: 52,
      rating: 4.6,
      status: "Active",
      isVerified: true,
      isPremium: false,
      displayOrder: 3,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
    { 
      id: 4, 
      brandCode: "BRD004",
      brandName: "Samsung", 
      country: "South Korea",
      website: "www.samsung.com",
      email: "contact@samsung.com",
      phone: "+82-2-2255-0114",
      description: "Electronics and consumer appliances",
      productCount: 67,
      rating: 4.7,
      status: "Active",
      isVerified: true,
      isPremium: true,
      displayOrder: 4,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
    { 
      id: 5, 
      brandCode: "BRD005",
      brandName: "Godrej", 
      country: "India",
      website: "www.godrej.com",
      email: "info@godrej.com",
      phone: "+91-22-2518-8010",
      description: "Furniture and storage solutions",
      productCount: 29,
      rating: 4.2,
      status: "Active",
      isVerified: true,
      isPremium: false,
      displayOrder: 5,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
    { 
      id: 6, 
      brandCode: "BRD006",
      brandName: "Featherlite", 
      country: "India",
      website: "www.featherliteonline.com",
      email: "support@featherlite.com",
      phone: "+91-80-4344-4444",
      description: "Office furniture and seating",
      productCount: 34,
      rating: 4.4,
      status: "Active",
      isVerified: true,
      isPremium: false,
      displayOrder: 6,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
    { 
      id: 7, 
      brandCode: "BRD007",
      brandName: "Canon", 
      country: "Japan",
      website: "www.canon.com",
      email: "contact@canon.com",
      phone: "+81-3-3758-2111",
      description: "Cameras, printers and imaging solutions",
      productCount: 41,
      rating: 4.5,
      status: "Active",
      isVerified: true,
      isPremium: true,
      displayOrder: 7,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
    { 
      id: 8, 
      brandCode: "BRD008",
      brandName: "TP-Link", 
      country: "China",
      website: "www.tp-link.com",
      email: "support@tp-link.com",
      phone: "+86-755-2650-4400",
      description: "Networking equipment and accessories",
      productCount: 25,
      rating: 4.1,
      status: "Active",
      isVerified: true,
      isPremium: false,
      displayOrder: 8,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
    { 
      id: 9, 
      brandCode: "BRD009",
      brandName: "Generic Brand", 
      country: "India",
      website: "",
      email: "",
      phone: "",
      description: "Generic unbranded products",
      productCount: 0,
      rating: 0,
      status: "Inactive",
      isVerified: false,
      isPremium: false,
      displayOrder: 99,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
    { 
      id: 10, 
      brandCode: "BRD010",
      brandName: "Lenovo", 
      country: "China",
      website: "www.lenovo.com",
      email: "support@lenovo.com",
      phone: "+86-10-5886-8888",
      description: "Computers and technology solutions",
      productCount: 48,
      rating: 4.4,
      status: "Active",
      isVerified: true,
      isPremium: true,
      displayOrder: 9,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [countryFilter, setCountryFilter] = useState("all");
  const [verifiedFilter, setVerifiedFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [editingBrand, setEditingBrand] = useState(null);
  const [viewingBrand, setViewingBrand] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [newBrand, setNewBrand] = useState({
    brandCode: "",
    brandName: "",
    country: "",
    website: "",
    email: "",
    phone: "",
    description: "",
    status: "Active",
    rating: 0,
    isVerified: false,
    isPremium: false,
    displayOrder: 1,
  });

  // Get unique countries for filter
  const countries = [...new Set(brandData.map(b => b.country).filter(Boolean))];

  // Helper functions
  const getFilteredBrands = () => {
    return brandData.filter((brand) => {
      const matchesSearch = Object.values(brand).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
      const matchesStatus = statusFilter === "all" || brand.status === statusFilter;
      const matchesCountry = countryFilter === "all" || brand.country === countryFilter;
      const matchesVerified = verifiedFilter === "all" || 
        (verifiedFilter === "verified" && brand.isVerified) ||
        (verifiedFilter === "unverified" && !brand.isVerified);
      return matchesSearch && matchesStatus && matchesCountry && matchesVerified;
    });
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Active':
        return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
      case 'Inactive':
        return { backgroundColor: '#ffebee', color: '#d32f2f' };
      default:
        return { backgroundColor: '#f5f5f5', color: '#666' };
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newBrand.brandName.trim()) newErrors.brandName = 'Brand name is required';
    if (!newBrand.country.trim()) newErrors.country = 'Country is required';
    if (newBrand.email && !newBrand.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      newErrors.email = 'Invalid email format';
    }
    if (!newBrand.displayOrder || newBrand.displayOrder <= 0) {
      newErrors.displayOrder = 'Display order must be greater than 0';
    }
    return newErrors;
  };

  // Handlers
  const handleEdit = (brand) => {
    setEditingBrand(brand);
    setNewBrand({ ...brand });
    setOpenModal(true);
  };

  const handleView = (brand) => {
    setViewingBrand(brand);
    setOpenViewModal(true);
  };

  const handleDelete = (id) => {
    const brandToDelete = brandData.find(b => b.id === id);
    
    if (brandToDelete.productCount > 0) {
      alert(`Cannot delete brand with ${brandToDelete.productCount} products. Please reassign or delete products first.`);
      return;
    }

    if (window.confirm("Are you sure you want to delete this brand?")) {
      setBrandData(brandData.filter((brand) => brand.id !== id));
      setSuccessMessage("Brand deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Search and filter handlers
  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredBrands().length} brands.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setCountryFilter("all");
    setVerifiedFilter("all");
    setPage(0);
    setErrors({});
    setSuccessMessage("");
  };

  const handleOpenModal = () => {
    setEditingBrand(null);
    setNewBrand({
      brandCode: "",
      brandName: "",
      country: "",
      website: "",
      email: "",
      phone: "",
      description: "",
      status: "Active",
      rating: 0,
      isVerified: false,
      isPremium: false,
      displayOrder: 1,
    });
    setErrors({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingBrand(null);
    setErrors({});
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setViewingBrand(null);
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    setNewBrand({ 
      ...newBrand, 
      [name]: type === 'checkbox' ? checked : value 
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleAddBrand = async () => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsLoading(true);
    try {
      if (editingBrand) {
        // Update existing brand
        setBrandData(brandData.map(brand => 
          brand.id === editingBrand.id 
            ? { 
                ...brand, 
                ...newBrand,
                updatedDate: new Date().toISOString().split('T')[0]
              }
            : brand
        ));
        setSuccessMessage("Brand updated successfully!");
      } else {
        // Add new brand
        const newId = brandData.length > 0 ? Math.max(...brandData.map(b => b.id)) + 1 : 1;
        const brandCode = `BRD${String(newId).padStart(3, '0')}`;
        setBrandData([...brandData, { 
          id: newId, 
          ...newBrand,
          brandCode: newBrand.brandCode || brandCode,
          productCount: 0,
          createdDate: new Date().toISOString().split('T')[0],
          updatedDate: new Date().toISOString().split('T')[0]
        }]);
        setSuccessMessage("Brand added successfully!");
      }
      handleCloseModal();
    } catch (error) {
      setErrors({ general: "An error occurred. Please try again." });
    } finally {
      setIsLoading(false);
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const filteredBrands = getFilteredBrands();

  // Calculate statistics
  const totalBrands = brandData.length;
  const activeBrands = brandData.filter(b => b.status === "Active").length;
  const verifiedBrands = brandData.filter(b => b.isVerified).length;
  const premiumBrands = brandData.filter(b => b.isPremium).length;
  const totalProducts = brandData.reduce((sum, brand) => sum + brand.productCount, 0);
  const avgRating = (brandData.reduce((sum, brand) => sum + brand.rating, 0) / brandData.filter(b => b.rating > 0).length).toFixed(1);

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Badge badgeContent={totalBrands} color="primary">
            <BrandIcon sx={{ color: 'primary.main', fontSize: 40 }} />
          </Badge>
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              Brand Master Management
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage product brands and manufacturers • {filteredBrands.length} brands found
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            fontWeight: 600,
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          Add New Brand
        </Button>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Statistics Cards */}
      {/* <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <BrandIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="primary">
                {totalBrands}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Brands
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <CheckCircleIcon sx={{ fontSize: 40, color: 'success.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="success.main">
                {activeBrands}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Active Brands
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <VerifiedIcon sx={{ fontSize: 40, color: 'info.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="info.main">
                {verifiedBrands}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Verified Brands
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <PopularIcon sx={{ fontSize: 40, color: 'warning.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="warning.main">
                {premiumBrands}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Premium Brands
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <StarIcon sx={{ fontSize: 40, color: 'error.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="error.main">
                {avgRating || 'N/A'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Avg Rating
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid> */}

      {/* Search and Filter Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3.5}>
            <TextField
              fullWidth
              label="Search Brands..."
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Filter by Country"
              value={countryFilter}
              onChange={(e) => setCountryFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Countries</option>
              {countries.map((country) => (
                <option key={country} value={country}>{country}</option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Verification"
              value={verifiedFilter}
              onChange={(e) => setVerifiedFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Brands</option>
              <option value="verified">Verified Only</option>
              <option value="unverified">Unverified Only</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={1.5}>
            <TextField
              select
              fullWidth
              label="Status"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                onClick={handleSearch}
                startIcon={<SearchIcon />}
                sx={{ flex: 1 }}
              >
                Search
              </Button>
              <Button
                variant="outlined"
                onClick={handleReset}
                startIcon={<RefreshIcon />}
                sx={{ flex: 1 }}
              >
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Table Section */}
      <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Brand Code</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Brand Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Country</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Contact</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Products</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Rating</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredBrands.length > 0 ? (
                filteredBrands
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((brand, index) => (
                    <TableRow 
                      key={brand.id} 
                      sx={{ 
                        '&:hover': { backgroundColor: '#f5f5f5' },
                        transition: 'background-color 0.2s'
                      }}
                    >
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <TagIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                          {brand.brandCode}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="body2" fontWeight="600">
                            {brand.brandName}
                          </Typography>
                          {brand.isVerified && (
                            <VerifiedIcon sx={{ fontSize: 18, color: 'info.main' }} />
                          )}
                          {brand.isPremium && (
                            <StarIcon sx={{ fontSize: 18, color: 'warning.main' }} />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <LocationIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                          {brand.country}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          {brand.phone && (
                            <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <PhoneIcon sx={{ fontSize: 12 }} />
                              {brand.phone}
                            </Typography>
                          )}
                          {brand.email && (
                            <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <EmailIcon sx={{ fontSize: 12 }} />
                              {brand.email}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography 
                          sx={{ 
                            fontWeight: 600,
                            color: brand.productCount === 0 ? 'text.secondary' : 'primary.main'
                          }}
                        >
                          {brand.productCount}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {brand.rating > 0 ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Rating value={brand.rating} precision={0.1} size="small" readOnly />
                            <Typography variant="caption">({brand.rating})</Typography>
                          </Box>
                        ) : (
                          <Typography variant="caption" color="text.secondary">N/A</Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                          {brand.isVerified && (
                            <Chip 
                              label="Verified" 
                              size="small" 
                              color="info"
                              icon={<VerifiedIcon />}
                              sx={{ fontSize: '0.7rem' }}
                            />
                          )}
                          {brand.isPremium && (
                            <Chip 
                              label="Premium" 
                              size="small" 
                              color="warning"
                              icon={<StarIcon />}
                              sx={{ fontSize: '0.7rem' }}
                            />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={brand.status}
                          size="small"
                          sx={{
                            ...getStatusStyle(brand.status),
                            fontWeight: 600,
                            fontSize: '0.75rem'
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              onClick={() => handleView(brand)}
                              sx={{
                                color: 'info.main',
                                '&:hover': {
                                  backgroundColor: 'info.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Brand">
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(brand)}
                              sx={{
                                color: 'warning.main',
                                '&:hover': {
                                  backgroundColor: 'warning.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Brand">
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(brand.id)}
                              sx={{
                                color: 'error.main',
                                '&:hover': {
                                  backgroundColor: 'error.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                    <BrandIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body1" color="text.secondary">
                      No brands found
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Try adjusting your search criteria or add a new brand.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredBrands.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </Paper>

      {/* Add/Edit Brand Modal */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <BrandIcon />
            {editingBrand ? 'Edit Brand' : 'Add New Brand'}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Brand Code"
                name="brandCode"
                value={newBrand.brandCode}
                onChange={handleInputChange}
                helperText="Auto-generated if left empty"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <TagIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Brand Name"
                name="brandName"
                value={newBrand.brandName}
                onChange={handleInputChange}
                error={!!errors.brandName}
                helperText={errors.brandName}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Country"
                name="country"
                value={newBrand.country}
                onChange={handleInputChange}
                error={!!errors.country}
                helperText={errors.country}
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Website"
                name="website"
                value={newBrand.website}
                onChange={handleInputChange}
                placeholder="www.example.com"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <WebsiteIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={newBrand.email}
                onChange={handleInputChange}
                error={!!errors.email}
                helperText={errors.email}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone"
                name="phone"
                value={newBrand.phone}
                onChange={handleInputChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Display Order"
                name="displayOrder"
                type="number"
                value={newBrand.displayOrder}
                onChange={handleInputChange}
                error={!!errors.displayOrder}
                helperText={errors.displayOrder || "Order in which brand appears"}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Rating (0-5)"
                name="rating"
                type="number"
                value={newBrand.rating}
                onChange={handleInputChange}
                inputProps={{ min: 0, max: 5, step: 0.1 }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={newBrand.status}
                  onChange={handleInputChange}
                  label="Status"
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newBrand.isVerified}
                    onChange={handleInputChange}
                    name="isVerified"
                    color="primary"
                  />
                }
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <VerifiedIcon sx={{ fontSize: 18 }} />
                    Verified Brand
                  </Box>
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newBrand.isPremium}
                    onChange={handleInputChange}
                    name="isPremium"
                    color="warning"
                  />
                }
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <StarIcon sx={{ fontSize: 18 }} />
                    Premium Brand
                  </Box>
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={newBrand.description}
                onChange={handleInputChange}
                multiline
                rows={3}
                placeholder="Enter brand description..."
              />
            </Grid>
          </Grid>
          {errors.general && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errors.general}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseModal} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddBrand}
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={20} /> : <AddIcon />}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            {isLoading ? 'Processing...' : (editingBrand ? 'Update Brand' : 'Add Brand')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Brand Modal */}
      <Dialog open={openViewModal} onClose={handleCloseViewModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon />
            Brand Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          {viewingBrand && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Avatar 
                    sx={{ 
                      width: 80, 
                      height: 80, 
                      margin: '0 auto',
                      backgroundColor: 'primary.main',
                    }}
                  >
                    <CompanyIcon sx={{ fontSize: 40 }} />
                  </Avatar>
                  <Typography variant="h5" sx={{ mt: 2, fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                    {viewingBrand.brandName}
                    {viewingBrand.isVerified && (
                      <VerifiedIcon sx={{ color: 'info.main' }} />
                    )}
                    {viewingBrand.isPremium && (
                      <StarIcon sx={{ color: 'warning.main' }} />
                    )}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {viewingBrand.brandCode}
                  </Typography>
                  {viewingBrand.rating > 0 && (
                    <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                      <Rating value={viewingBrand.rating} precision={0.1} readOnly />
                      <Typography variant="body2" color="text.secondary">
                        ({viewingBrand.rating})
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Country</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <LocationIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                    <Typography variant="body1" fontWeight="bold">
                      {viewingBrand.country}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Total Products</Typography>
                  <Typography variant="body1" fontWeight="bold" color="primary">
                    {viewingBrand.productCount} Products
                  </Typography>
                </Paper>
              </Grid>
              
              {viewingBrand.website && (
                <Grid item xs={12}>
                  <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                    <Typography variant="caption" color="text.secondary">Website</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                      <WebsiteIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                      <Typography variant="body1" fontWeight="bold">
                        {viewingBrand.website}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              )}
              
              {viewingBrand.email && (
                <Grid item xs={12} sm={6}>
                  <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                    <Typography variant="caption" color="text.secondary">Email</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                      <EmailIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                      <Typography variant="body1" fontWeight="bold">
                        {viewingBrand.email}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              )}
              
              {viewingBrand.phone && (
                <Grid item xs={12} sm={6}>
                  <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                    <Typography variant="caption" color="text.secondary">Phone</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                      <PhoneIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                      <Typography variant="body1" fontWeight="bold">
                        {viewingBrand.phone}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              )}
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Status</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip
                      label={viewingBrand.status}
                      sx={{
                        ...getStatusStyle(viewingBrand.status),
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Display Order</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingBrand.displayOrder}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Description</Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {viewingBrand.description || 'No description available'}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Created Date</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingBrand.createdDate}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Last Updated</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingBrand.updatedDate}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseViewModal}>Close</Button>
          {viewingBrand && (
            <Button
              variant="contained"
              onClick={() => {
                handleCloseViewModal();
                handleEdit(viewingBrand);
              }}
              startIcon={<EditIcon />}
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }}
            >
              Edit Brand
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default BrandMaster;

